module.exports = __webpack_public_path__ + "img/nodata_items.098d8aa1.png";